export interface PartnersState {
  partners: any[]
}

export const initialPartnersState: PartnersState = {
  partners: []
};
